import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-actions }}",{ moduleName: "embercom/components/app-framework/messenger-apps/canvas.hbs" })